import React, { Component } from 'react';
import ModelDataManager from "./ModelDataManager";
import {isDataModelLoaded} from "../../stateGetter";
import ItemManager from "./ItemManager";
import ResultManager from "./ResultManager";
import {connect} from "~/redux/connect";
import {getModelName, getModelNameOrNull} from "~/stateGetter";
import { Box } from "~/native-ui";

class ModelManager extends Component {
	renderModelManagers = () => {
        let { modelId } = this.props;

		let managers = [
			<ItemManager modelId={modelId} key="ItemManager" />,
			<ResultManager modelId={modelId} key="ResultManager" />,
		];

		return managers;
	};
	
	render() {
		let { modelId, isDataModelLoaded } = this.props;

		if(!modelId) { return null; }

		return (
			<Box display="none">
				<ModelDataManager modelId={modelId} />
				{isDataModelLoaded && this.renderModelManagers()}
			</Box>
		);
	}
}

const RXModelManager = connect(
	(state, {modelId}) => {
        // console.log('CHANGED B', state.lastAction.type, modelId);


		return {
            modelId,
            isDataModelLoaded: isDataModelLoaded(state, modelId),

		}
	},
)(ModelManager);

export default RXModelManager;